import { useIsAuthorisedHook } from '@nile/components';
import React, { useState } from 'react';
import { Banner, Button, TextStyle } from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage } from 'react-intl';

const PaymentOverDueBanner = ({ invoiceCount }) => {
  const isBillingAndInvoiceViewAuthorised = useIsAuthorisedHook(
    'billingAndInvoice.view'
  );

  const [loading, setLoading] = useState(false);
  let timeout = null;

  const redirectToProvider = () => {
    setLoading(true);
    window.location.assign(
      `${localStorage?.getItem('apiDomain') +
        envConfig.accountsBasePath}/integration/chargebee/collectnow/init`
    );
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const getBannerData = () => {
    if (isBillingAndInvoiceViewAuthorised) {
      return {
        status: 'warning',
        count: invoiceCount || null,
        message:
          invoiceCount > 1
            ? 'app.multiple.payment.pending.warning.message'
            : 'app.payment.pending.warning.message'
      };
    }
    return {
      status: 'info',
      count: invoiceCount || null,
      message:
        invoiceCount > 1
          ? 'app.multiple.payment.pending.info.message'
          : 'app.payment.pending.info.message'
    };
  };

  const { status, message, count } = getBannerData();

  return (
    <Banner status={status}>
      <div className="flex g5 actr">
        <div>
          <FormattedMessage
            id={message}
            values={{
              count: count
            }}
          />
        </div>
        {isBillingAndInvoiceViewAuthorised && (
          <div>
            <Button
              plain
              onClick={redirectToProvider}
              loading={loading}
              disabled={loading}
            >
              <FormattedMessage id="common.make.payment" />
            </Button>
          </div>
        )}
      </div>
    </Banner>
  );
};

export default PaymentOverDueBanner;
